module.exports = __webpack_public_path__ + "static/media/comments-alt-dollar.dbdf4ca8.svg";